import React from "react";
import { Redirect } from "react-router-dom";

// File pages
import EspaceAgent from "../pages/EspaceAgent/index";
import DossiersCgos from "../pages/DossiersCgos/index";
import Dod from "../pages/Dod/index";

// File Viewer 
import PdfViewer from "../pages/viewer/PdfViewer";
import ItsoftFileViewer from "../pages/viewer/ItsoftFileViewer";
import DodFileViewer from "../pages/viewer/DodFileViewer";
import DossierMetier from "../pages/viewer/DossierMetier";

// Authentication related pages
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import SsoLogin from "../pages/ssoLogin/SsoLogin";

//error pages
import Pages404 from "../pages/Erreur/pages-404";
import Pages500 from "../pages/Erreur/pages-500";
import PdfViewerLegacy from "../pages/viewer/PdfViewerLegacy";

const authProtectedRoutes = [

  //Espace Agent
  { path: "/espaceagent", component: EspaceAgent },

  // Dossier CGOS
  { path: "/dossiercgos", component: DossiersCgos },

  // Dod
  { path: "/dod", component: Dod },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/espaceagent" /> },

  { path: "*", component: () => <Redirect to="/error/404" />}
];

const publicRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/sso/metier/:login/:password/:numeroCgos/:exercice", component: SsoLogin },
  { path: "/fileview", component: PdfViewer },
  { path: "/file/:id", component: PdfViewerLegacy },
  { path: "/itsoft/:id", component: ItsoftFileViewer },
  { path: "/dod/:id", component: DodFileViewer },
  { path: "/dossiermetier/:numSecu/:exercice", component: DossierMetier },
  { path: "/error/404", component: Pages404},
  { path: "/error/500", component: Pages500},
];

export { authProtectedRoutes, publicRoutes };
